import { Navigate, Route } from "react-router-dom";

import { routes } from "constants/routes";
import UserSettings from "features/main/UserSettings";
import UserAccount from "features/main/UserSettings/Account";
import UserBilling from "features/main/UserSettings/Billing";
import BillingReceipt from "features/main/UserSettings/Billing/BillingReceipt";
import Help from "features/main/UserSettings/Help";
import UserNotifications from "features/main/UserSettings/Notifications";
import UserSettingProfile from "features/main/UserSettings/Profile";
import Theme from "features/main/UserSettings/Theme";
import BankAccountSettings from "features/main/UserSettings/BankAccount";
import API from "../../features/main/UserSettings/API";
import Integrations from "features/main/UserSettings/Integrations";
import AlvysIntegration from "features/main/UserSettings/Integrations/Alvys";

export default function SettingsRoutes() {
  return (
    <Route path={routes.SETTINGS}>
      <Route index element={<UserSettings />} />
      <Route path={routes.SETTINGS_ACCOUNT} element={<UserAccount />} />
      <Route path={routes.SETTINGS_PROFILE} element={<UserSettingProfile />} />
      <Route path={routes.SETTINGS_NOTIFICATIONS} element={<UserNotifications />} />
      <Route path={routes.SETTINGS_BILLING} element={<UserBilling />} />
      <Route path={routes.SETTINGS_BILLING_RECEIPT} element={<BillingReceipt />}></Route>
      <Route path={routes.SETTINGS_HELP} element={<Help />} />
      <Route path={routes.SETTINGS_THEME} element={<Theme />} />
      <Route path={routes.SETTINGS_BANK_ACCOUNT} element={<BankAccountSettings />} />
      <Route
        path={routes.SETTINGS_API}
        element={<Navigate to={routes.SETTINGS_INTEGRATIONS_API} replace />}
      />
      <Route path={routes.SETTINGS_INTEGRATIONS} element={<Integrations />} />
      <Route path={routes.SETTINGS_INTEGRATIONS_API} element={<API />} />
      <Route path={routes.SETTINGS_INTEGRATIONS_ALVYS} element={<AlvysIntegration />} />
    </Route>
  );
}
